import {
    afterRenderEffect,
    DestroyRef,
    Directive,
    ElementRef,
    inject,
    input,
    signal,
} from '@angular/core';

@Directive({
    selector: '[qpxSuggestionRowFit]',
    exportAs: 'suggestionRowFit',
})
export class SuggestionRowFit {
    private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly destroyRef = inject(DestroyRef);
    public readonly enabled = input(false, { alias: 'qpxSuggestionRowFit' });
    public readonly contentKey = input('');
    public readonly compact = signal(false);
    public readonly truncated = signal(false);

    constructor() {
        let observer: ResizeObserver | undefined;
        let frame: number | undefined;
        const disconnect = () => {
            observer?.disconnect();
            if (frame !== undefined) cancelAnimationFrame(frame);
            frame = undefined;
        };
        afterRenderEffect(() => {
            disconnect();
            this.contentKey();
            if (!this.enabled()) {
                this.compact.set(false);
                this.truncated.set(false);
                return;
            }
            const row = this.element.nativeElement;
            const label = row.querySelector<HTMLElement>('.question-label');
            const measure = row.querySelector<HTMLElement>('.category-measure');
            const questionMeasure =
                row.querySelector<HTMLElement>('.question-measure');
            const fit = () => {
                if (!label) return;
                const available = row.getBoundingClientRect().width;
                if (available <= 0) return;
                const gap =
                    Number.parseFloat(getComputedStyle(row).columnGap) || 0;
                if (measure && questionMeasure) {
                    questionMeasure.style.width = `${Math.max(0, available - measure.getBoundingClientRect().width - gap)}px`;
                    const lineHeight = Number.parseFloat(
                        getComputedStyle(label).lineHeight
                    );
                    this.compact.set(
                        questionMeasure.scrollHeight > lineHeight * 2 + 1
                    );
                }
                this.truncated.set(label.scrollHeight > label.clientHeight);
            };
            if (typeof ResizeObserver !== 'undefined') {
                observer = new ResizeObserver(() => {
                    if (frame !== undefined) return;
                    frame = requestAnimationFrame(() => {
                        frame = undefined;
                        fit();
                    });
                });
                observer.observe(row);
                if (label) observer.observe(label);
                if (measure) observer.observe(measure);
                if (questionMeasure) observer.observe(questionMeasure);
            }
            fit();
        });
        this.destroyRef.onDestroy(disconnect);
    }
}
